import { Box, Typography } from '@mui/material';

const FinanceXSubscriptionDetailComponent = function (): JSX.Element {
  return (
    <Box sx={{ padding: '40px' }}>
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>
        Subscription Detail
      </Typography>
    </Box>
  );
};

export default FinanceXSubscriptionDetailComponent;
